//
export default {
  console: {
    getLanguage: '/frontend/webMethods/Console.asmx/GetLanguage',
    getPendoSettings: '/frontend/webMethods/Console.asmx/GetPendoSettings'
  },
  languages: {
    da: '/App/lang/da_DA.json',
    de: '/App/lang/de_DE.json',
    en: '/App/lang/en_US.json',
    es: '/App/lang/es_ES.json',
    fr: '/App/lang/fr_FR.json',
    id: '/App/lang/id_ID.json',
    it: '/App/lang/it_IT.json',
    ja: '/App/lang/ja_JP.json',
    pt: '/App/lang/pt_PT.json',
    zh: '/App/lang/zh_CN.json',
    tr: '/App/lang/tr_TR.json',
    el: '/App/lang/el_GR.json'
  },
  preferencecenter: {
    getAutoprofileFormAvailability: '/frontend/webMethods/PreferenceCenter.asmx/GetAutoprofileFormAvailability',
    getDefaultListValues: '/frontend/webMethods/PreferenceCenter.asmx/GetDefaultListValues',
    getSubscriberEmail: '/frontend/webMethods/PreferenceCenter.asmx/GetSubscriberEmail',
    loadPrefCenterOptions: '/frontend/webMethods/PreferenceCenter.asmx/LoadPrefCenterOptions',
    loadSubscriberPreferences: '/frontend/webMethods/PreferenceCenter.asmx/LoadSubscriberPreferences',
    saveSubscriberPreferences: '/frontend/webMethods/PreferenceCenter.asmx/SaveSubscriberPreferences'
  },
  exportService: {
    exportAnagrData: '/frontend/webMethods/ExportServiceFrontend.asmx/PreferenceCenterExportAnagrData'
  },
  msg: {
    getDefaultListValues: '/frontend/webMethods/Msg.asmx/GetDefaultListValues',
    getNewsletterList: '/frontend/webMethods/Msg.asmx/GetNewsletterList',
    getSubscriberEmail: '/frontend/webMethods/Msg.asmx/GetSubscriberEmail',
    isOptin: '/frontend/webMethods/Msg.asmx/IsOptin',
    getSubscriberData: '/frontend/webMethods/Msg.asmx/GetSubscriberData'
  },
  personalization: {
    getListSettings: '/frontend/webMethods/Personalization.asmx/GetListSettings'
  },
  publicCustom: {
    getAction: '/frontend/webMethods/PublicCustom.asmx/GetAction',
    getActionForRecipient: '/frontend/webMethods/PublicCustom.asmx/GetActionForRecipient',
    getText: '/frontend/webMethods/PublicCustom.asmx/GetText',
    getSettings: '/frontend/webMethods/PublicCustom.asmx/GetSettings',
    getListGUID: '/frontend/webMethods/PublicCustom.asmx/GetListGUID',
    getClientIP: '/frontend/webMethods/PublicCustom.asmx/GetClientIP',
    getCustomFlowConfig: '/frontend/webMethods/PublicCustom.asmx/GetCustomFlowConfig'
  }

}
